const BREAK_POINTS = {
  mobile: 720,
  desktop: 1200,
};

export default BREAK_POINTS;
